import React from "react";
import { Layout } from "antd";
import OnboardingHeader from "./OnboardingHeader";
import OnboardingFooter from "./OnboardingFooter";

const { Content } = Layout;

const OnboardingLayout = ({
  children,
  currentStep,
  goBack,
  close = () => {},
}) => {
  return (
    <Layout className="flex flex-col min-h-screen">
      {/* Header with dynamic Back button */}
      <OnboardingHeader
        title="Create account"
        onBack={currentStep > 0 ? goBack : undefined}
        onClose={close}
      />

      {/* Main Content */}
      <Content className="flex-grow bg-white p-6 flex items-center justify-center">
        {children}
      </Content>

      {/* Footer */}
      <OnboardingFooter />
    </Layout>
  );
};

export default OnboardingLayout;
